export class AssigneeUtil {

  static getLabel(user: { name?: string; email?: string } | null | undefined): string {
    const name = user?.name || '';
    const email = user?.email || '';
    if (!email && !name) return '';
    return email ? `${email} (${name})` : `(${name})`;
  }
}
